<div class="modal-header">
    <h3 class="modal-title">quantity limit</h3>
    <button class="btn-close" (click)="closeModal()">
        <img src="assets/icons/{{baseSiteId}}/close.svg" alt="">
    </button>
</div>
<div class="modal-body">
    <h3>Your quantity limit for <span [innerHTML]="productDetails.name"></span></h3>
    <div class="d-flex flex-row justify-content-between">

        <div class="inner-flex-units-container d-flex col-sm-5 flex-column">
            <div class="d-flex flex-row">
                <div class="col-sm-7">Total allocation</div>
                <div class="col-sm-5">{{productDetails.allotted}} Units</div>
            </div>
            <div class="d-flex flex-row">
                <div class="col-sm-7">Units ordered to date</div>
                <div class="col-sm-5">{{productDetails.consumed}} Units</div>
            </div>
            <div class="d-flex flex-row">
                <div class="col-sm-7"> Units remaining</div>
                <div class="col-sm-5" [ngClass]="productDetails.available == '0' ? 'zeroUnits' : 'moreUnits'">{{productDetails.available}} Units</div>   
            </div>
        </div>
        <div class="extra-note col-sm-6" *ngIf="productDetails.available == '0'">
            <h4>Note:<br>
                The product doesnot have any available units
            </h4>
        </div>
        <div class="extra-note col-sm-6" *ngIf="productDetails.available !== '0'">
            <h4>Note: <br>
                This product is limited to {{productDetails.allotted}} units {{productDetails.frequency}}.
            </h4>
        </div>
    </div>
</div>

<div class="modal-footer container">
    <h4>Need assistance? Call <span *ngIf="baseSiteId == 'vsh'">1-800-VACCINE (1-800-822-2463).</span>
        <span *ngIf="baseSiteId == 'vax'">1-800-752-9338.</span>
    </h4>
</div>